export const SIGNUP_REASON_OPTIONS = [
  { code: 10, label: 'Research Myself' },
  { code: 20, label: 'Contacting Others' },
  { code: 21, label: 'Verifying Information' },
  { code: 22, label: 'Relationships' },
  { code: 18, label: 'Professional Use' },
  { code: 99, label: 'Other' },
] as const;

export type SignupReasonOption = (typeof SIGNUP_REASON_OPTIONS)[number];
export type SignupReasonCode = SignupReasonOption['code'];

export type AccountSetupMode = 'both' | 'phone' | 'signupReason';

export interface AccountSetupModalCopy {
  title: string;
  subtitle: string;
}

export const ACCOUNT_SETUP_MODAL_COPY: Record<
  AccountSetupMode,
  AccountSetupModalCopy
> = {
  both: {
    title: 'Finish setting up your account',
    subtitle:
      'A couple of quick details so we can secure your account and tailor your results.',
  },
  phone: {
    title: 'Add your phone number',
    subtitle:
      "We'll use this to help you recover your account if you ever get locked out.",
  },
  signupReason: {
    title: 'What brings you to BeenVerified?',
    subtitle:
      "Tell us what you're looking for so we can tailor your search results.",
  },
};

export const ACCOUNT_SETUP_SUCCESS_COPY: Record<
  AccountSetupMode,
  AccountSetupModalCopy
> = {
  signupReason: {
    title: 'All set',
    subtitle: "Thanks — we'll use this to tailor your search experience",
  },
  phone: {
    title: 'All set',
    subtitle: 'Thanks for updating your account information!',
  },
  both: {
    title: 'All set',
    subtitle: 'We have updated your data',
  },
};
